/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CheckEligibilityResponse } from './CheckEligibilityResponse';
import {
    CheckEligibilityResponseFromJSON,
    CheckEligibilityResponseFromJSONTyped,
    CheckEligibilityResponseToJSON,
} from './CheckEligibilityResponse';

/**
 * 
 * @export
 * @interface CheckEligibility200Response
 */
export interface CheckEligibility200Response {
    /**
     * 
     * @type {CheckEligibilityResponse}
     * @memberof CheckEligibility200Response
     */
    data?: CheckEligibilityResponse;
}

/**
 * Check if a given object implements the CheckEligibility200Response interface.
 */
export function instanceOfCheckEligibility200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CheckEligibility200ResponseFromJSON(json: any): CheckEligibility200Response {
    return CheckEligibility200ResponseFromJSONTyped(json, false);
}

export function CheckEligibility200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CheckEligibility200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : CheckEligibilityResponseFromJSON(json['data']),
    };
}

export function CheckEligibility200ResponseToJSON(value?: CheckEligibility200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': CheckEligibilityResponseToJSON(value.data),
    };
}

